import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { ChonkyActions, FileBrowser, FileList, FileNavbar, FileToolbar } from 'chonky';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "file-browser-handle"
    }}>{`File Browser handle`}</h1>
    <p>{`You can access the file browser handle by passing a React ref to the `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{`
component, as shown below. You can see the list of available methods in `}<a parentName="p" {...{
        "href": "/docs/2.x/api/file-browser-handle"
      }}>{`file browser
handle API reference`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { FileBrowser, FileBrowserHandle } from 'chonky';

const MyFileBrowser = () => {
    // \`FileBrowserHandle\` is an interface exported from \`chonky\`.
    const fileBrowserRef = React.useRef<FileBrowserHandle>(null);
    return (
        <FileBrowser ref={fileBrowserRef} files={[]}>
            {/* ... */}
        </FileBrowser>
    );
};
`}</code></pre>
    <br />
    <p>{`Live example below shows the different ways file browse handle can be used.`}</p>
    <Playground __position={1} __code={'() => {\n  const files = React.useMemo(\n    () => [\n      { id: \'zxc\', name: \'One\' },\n      { id: \'dfg\', name: \'Two\' },\n      { id: \'mds\', name: \'Three\' },\n      { id: \'asd\', name: \'Four\' },\n      { id: \'bgr\', name: \'Five\' },\n      { id: \'ojw\', name: \'Six\' },\n      { id: \'mew\', name: \'Seven\' },\n      { id: \'lre\', name: \'Eight\' },\n    ],\n    [],\n  )\n  const fileBrowserRef = React.useRef(null)\n  const selectRandomFiles = React.useCallback(() => {\n    if (!fileBrowserRef.current) return\n    const newSelection = new Set()\n    for (const file of files) {\n      if (Math.random() > 0.5) newSelection.add(file.id)\n    }\n    fileBrowserRef.current.setFileSelection(newSelection)\n  }, [files])\n  const invertSelection = React.useCallback(() => {\n    if (!fileBrowserRef.current) return\n    const oldSelection = fileBrowserRef.current.getFileSelection()\n    const newSelection = new Set()\n    for (const file of files) {\n      if (!oldSelection.has(file.id)) newSelection.add(file.id)\n    }\n    fileBrowserRef.current.setFileSelection(newSelection)\n  }, [files])\n  const clearSelection = React.useCallback(() => {\n    if (!fileBrowserRef.current) return\n    fileBrowserRef.current.requestFileAction(ChonkyActions.ClearSelection)\n  }, [files])\n  return (\n    <>\n      <button className=\"demo-button\" onClick={selectRandomFiles}>\n        Select random files\n      </button>\n      <button className=\"demo-button\" onClick={invertSelection}>\n        Invert selection\n      </button>\n      <button className=\"demo-button\" onClick={clearSelection}>\n        Clear selection\n      </button>\n      <div style={{ height: 400 }}>\n        <FileBrowser ref={fileBrowserRef} files={files}>\n          <FileNavbar />\n          <FileToolbar />\n          <FileList />\n        </FileBrowser>\n      </div>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ChonkyActions,
      FileBrowser,
      FileList,
      FileNavbar,
      FileToolbar,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const files = React.useMemo(() => [{
          id: 'zxc',
          name: 'One'
        }, {
          id: 'dfg',
          name: 'Two'
        }, {
          id: 'mds',
          name: 'Three'
        }, {
          id: 'asd',
          name: 'Four'
        }, {
          id: 'bgr',
          name: 'Five'
        }, {
          id: 'ojw',
          name: 'Six'
        }, {
          id: 'mew',
          name: 'Seven'
        }, {
          id: 'lre',
          name: 'Eight'
        }], []);
        const fileBrowserRef = React.useRef(null);
        const selectRandomFiles = React.useCallback(() => {
          if (!fileBrowserRef.current) return;
          const newSelection = new Set();

          for (const file of files) {
            if (Math.random() > 0.5) newSelection.add(file.id);
          }

          fileBrowserRef.current.setFileSelection(newSelection);
        }, [files]);
        const invertSelection = React.useCallback(() => {
          if (!fileBrowserRef.current) return;
          const oldSelection = fileBrowserRef.current.getFileSelection();
          const newSelection = new Set();

          for (const file of files) {
            if (!oldSelection.has(file.id)) newSelection.add(file.id);
          }

          fileBrowserRef.current.setFileSelection(newSelection);
        }, [files]);
        const clearSelection = React.useCallback(() => {
          if (!fileBrowserRef.current) return;
          fileBrowserRef.current.requestFileAction(ChonkyActions.ClearSelection);
        }, [files]);
        return <>
                <button className="demo-button" onClick={selectRandomFiles}>
                    Select random files
                </button>
                <button className="demo-button" onClick={invertSelection}>
                    Invert selection
                </button>
                <button className="demo-button" onClick={clearSelection}>
                    Clear selection
                </button>
                <div style={{
            height: 400
          }}>
                    <FileBrowser ref={fileBrowserRef} files={files} mdxType="FileBrowser">
                        <FileNavbar mdxType="FileNavbar" />
                        <FileToolbar mdxType="FileToolbar" />
                        <FileList mdxType="FileList" />
                    </FileBrowser>
                </div>
            </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      